<template>
  <NuxtImg
    v-editable="blok"
    provider="storyblok"
    :src="blok.image?.filename"
    :alt="blok.image?.alt"
    :style="{
      width: `${blok.size}px`,
    }"
    loading="lazy"
  />
</template>

<script lang="ts" setup>
import type { SbPictureIconStoryblok } from '@/types'
interface Props {
  blok: SbPictureIconStoryblok
}
defineProps<Props>()
</script>
